import React from "react";
import RichText from "react-rte";
import { NOTIFICATION_TYPES } from "~/src/consts";
import TextInput from "~/src/components/form-components/text-input";
import Button from "~/src/components/button";
import {
  Container,
  ModalContent,
  ButtonContainer
} from "../notifications.styles";

export default function ComposeMessage(props) {
  return (
    <ModalContent>
      {props.activeNotificationTypes.includes(
        NOTIFICATION_TYPES.PUSH_NOTIFICATION
      ) &&
        props.canSendShiftID && (
          <TextInput
            isBorderless
            value={props.shiftId}
            label="Shift ID (push only)"
            placeholder="Write here"
            onChangeValue={shiftId => props.onComposeMessage({ shiftId })}
          />
        )}
      {props.activeNotificationTypes.includes(NOTIFICATION_TYPES.EMAIL) && (
        <TextInput
          isBorderless
          value={props.subject}
          label="Subject (email only)"
          placeholder="Write here"
          onChangeValue={subject => props.onComposeMessage({ subject })}
        />
      )}
      <Container flexDirection="column">
        <RichText
          value={props.messageBody}
          onChange={messageBody => props.onComposeMessage({ messageBody })}
        />
        <ButtonContainer>
          <Button onClick={props.onSubmit}>Send Message</Button>
        </ButtonContainer>
      </Container>
    </ModalContent>
  );
}
